import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';
import * as common from 'libs/commonFunc';

import { Progress, Dropdown, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import * as commonVar from 'libs/commonVar';

import styles from './EduSummaryItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduSummaryItem extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { edu, isOpen, selected } = this.props;
    // function
    const { onSelectEduSummary, onEduToggleModal } = this.props;
    const {
      eduNo,
      eduName,
      eduCount,
      examCount,
      beforeCount,
      afterCount,
      playCount,
      attachName,
      startEpoch,
      endEpoch
    } = edu.toJS();

    // 기간 종료
    const disabledEnd = endEpoch < common.nowEpoch() ? true : false;

    // 현재 진행상태
    let progress = 1;
    // 예약 교육
    let isReserveEdu = false;
    // let isEndActive = false;

    if (startEpoch > common.nowEpoch()) {
      progress = 0;
      isReserveEdu = true;
    } else {
      //progress = afterCount / eduCount * 100;
      progress = Math.round((common.nowEpoch() - startEpoch) / (endEpoch - startEpoch) * 100);

      // 만약 훈련 진행중인데 1%가 안되어도 1%로 표기
      progress = 1 > progress ? 1 : progress;
      // isEndActive = true;
    }
    if (progress >= 100) {
      progress = 100;
    }
    if (progress === 100) {
      // isEndActive = false;
    }

    return (
      <div
        className={cx('examSummaryItem-wrapper', 'eduSummaryItem-wrapper', 'bt-open', { selected: selected })}
        onClick={() => onSelectEduSummary(eduNo)}>
        <div className={cx('item-wrapper')}>
          <div className={cx('item-inner')}>
            <div className={cx('edu-summary-info')}>
              <div className={cx('eduName-wrap')}>
                {/* 훈련명 */}
                <div className={cx('eduName')}>
                  {/* 예약 교육 표시 */}
                  {isReserveEdu && (
                    <Tooltip
                      title={defineMessages(formatMessage({ id: 'Edu_56', defaultMessage: '예약 교육' }))}
                      classes={{ tooltip: 'tooltip-noMaxWidth' }}
                      placement="top">
                      <Image className={cx('mr-5 castop-icon')} src="/img/exam/cate_reserve.png" />
                    </Tooltip>
                  )}
                  <div className={cx('eduName-text')}>{eduName}</div>
                  <div className={cx('examSummary-bt-area')}>
                    {/* 수정, 삭제 버튼 */}
                    <Dropdown
                      floating
                      pointing="top right"
                      button
                      className="icon"
                      icon={<Image className={cx('ui image')} src="/img/exam/cate_setting.png" />}
                      className={cx('examSummary-dropdown')}>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          icon="write"
                          text={defineMessages(formatMessage({ id: 'ExamSummaryItem_1', defaultMessage: '수정' }))}
                          onClick={e => {
                            e.stopPropagation();
                            onEduToggleModal(eduNo, 'eduEdit');
                          }}
                        />
                        <Dropdown.Item
                          icon="trash"
                          text={defineMessages(formatMessage({ id: 'ExamSummaryItem_2', defaultMessage: '삭제' }))}
                          onClick={e => {
                            e.stopPropagation();
                            onEduToggleModal(eduNo, 'eduDelete');
                          }}
                        />
                        {/* <Dropdown.Divider /> */}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className={cx('attachName')}>
                <div>
                  <img className={cx('icon-edu-title')} src="/img/edu/icon_edu_title.png " />
                </div>
                <div className={cx('attachName-text')}>{attachName}</div>
              </div>
              <div className={cx('')}>
                {common.timeFormatFromUTCEpoch(startEpoch, 3)} ~ {common.timeFormatFromUTCEpoch(endEpoch, 3)}
              </div>
              <div className={cx('edu-summary-info-detail')}>
                <div className={cx('line-sub', 'line-sub-title')}>
                  <span className={cx('title')}>
                    {defineMessages(formatMessage({ id: 'ExamHeader_33', defaultMessage: '훈 련' }))}
                  </span>
                  <span className={cx('content', 'ellipsis')}>
                    {examCount + defineMessages(formatMessage({ id: 'ExamDetail_12', defaultMessage: '개' }))}
                  </span>
                </div>
                <div className={cx('edu-target-detail')}>
                  <div className={cx('line-sub')}>
                    <span className={cx('title')}>
                      {defineMessages(formatMessage({ id: 'ExamHeader_5', defaultMessage: '대 상' }))}
                    </span>
                    <span className={cx('content')}>
                      {eduCount + defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                    </span>
                  </div>
                  <div className={cx('target-detail-inner')}>
                    <div className={cx('line-sub')}>
                      <span className={cx('title')}>
                        ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'Edu_16', defaultMessage: '진행전' }))}
                      </span>
                      <span className={cx('content')}>
                        {beforeCount + defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                    <div className={cx('line-sub')}>
                      <span className={cx('title')}>
                        ·&nbsp;&nbsp;{defineMessages(formatMessage({ id: 'Edu_14', defaultMessage: '진행중' }))}
                      </span>
                      <span className={cx('content')}>
                        {playCount + defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                    <div className={cx('line-sub')}>
                      <span className={cx('title')}>
                        ·&nbsp;&nbsp;
                        {defineMessages(formatMessage({ id: 'Edu_15', defaultMessage: '완료' }))}
                      </span>
                      <span className={cx('content')}>
                        {afterCount + defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Tooltip
              title={
                isReserveEdu
                  ? defineMessages(formatMessage({ id: 'Edu_56', defaultMessage: '예약 교육' }))
                  : defineMessages(formatMessage({ id: 'ExamDetail_34', defaultMessage: '진행률' })) +
                    ': ' +
                    Math.floor(progress) +
                    '%'
              }
              placement="bottom">
              {/* 퍼센트가 10~15%일때 공간이 좁아서 일부러 넓여준다 */}
              <div className={cx('progress-area', { expansionBar: progress > 9 && progress < 16 })}>
                <Progress
                  percent={progress}
                  size={!isOpen ? 'tiny' : 'medium'}
                  // progress={isOpen}
                  inverted
                  indicating={isReserveEdu ? false : true}
                  disabled={isReserveEdu ? true : false}
                />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

EduSummaryItem.propTypes = {
  edu: ImmutablePropTypes.mapContains({
    eduNo: PropTypes.number,
    eduName: PropTypes.string,
    eduCount: PropTypes.number,
    beforeCount: PropTypes.number,
    playCount: PropTypes.number,
    afterCount: PropTypes.number,
    examCount: PropTypes.number,
    attachName: PropTypes.string,
    startEpoch: PropTypes.number,
    endEpoch: PropTypes.number
  }),
  isOpen: PropTypes.bool,
  onSelectEduSummary: PropTypes.func,
  onToggleExamSummary: PropTypes.func
};

export default injectIntl(EduSummaryItem);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduSummaryItem.js